<template>
    <c-dialog ref="dialog" title="核销确认单详情" mode="slide" width="85vw" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.record_number" class="m-detail-tag flex-center-cross">
                <label>{{detailData.record_number}}</label>
                <c-state async tag dict="CHECK_CONFIRM_STATUS" :value="detailData.status"></c-state>
            </div>
        </template>

        <module>
            <module-col size="310">
                <c-detail class="m-detail-form">
                    <c-detail-item label="核销单号">
                        {{detailData.record_number}}
                    </c-detail-item>
                    <c-detail-item label="收款渠道">
                        <c-state async tag dict="CHECK_PAYMENT_CHANNEL" :value="detailData.check_payment_channel"></c-state>
                    </c-detail-item>
                    <c-detail-item label="确认状态">
                        <c-state async dict="CHECK_CONFIRM_STATUS" :value="detailData.status"></c-state>
                    </c-detail-item>
                    <c-detail-item label="核销金额">
                        ￥{{detailData.settlement_amount||0}}
                    </c-detail-item>
                    <c-detail-item label="背贴码数量">
                        {{detailData.product_count||0}}
                    </c-detail-item>
                    <c-detail-item label="确认人">
                        {{detailData.confirm_user_realname}}
                    </c-detail-item>
                    <c-detail-item label="确认时间">
                        {{detailData.confirm_date}}
                    </c-detail-item>
                </c-detail>
            </module-col>

            <module-col tab-type="border-tab">
                <!--核销商品明细-->
                <module-tab name="核销商品明细" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="productList">
                            <c-table-column
                                    label="商品信息"
                                    width="230"
                            >
                                <template #default="{data}">
                                    {{getProductText(data)}}
                                </template>
                            </c-table-column>

                            <c-table-column
                                    name="produce_unique_code"
                                    label="背贴码"
                                    width="130"
                            >
                            </c-table-column>
                            <c-table-column
                                    name="order_no"
                                    label="小黑订单号"
                                    width="130"
                            >
                            </c-table-column>

                            <c-table-column label="销售货款" width="100">
                                <template #default="{data}">
                                    <span style="color: green">￥{{data.check_product_money||0}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="退款金额" width="100">
                                <template #default="{data}">
                                    <span style="color: red">￥{{data.check_return_money||0}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="补差金额" width="100">
                                <template #default="{data}">
                                    <span style="color: red">￥{{data.check_supplement_money||0}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="结算金额" width="100">
                                <template #default="{data}">
                                    <strong v-if="data.check_receipt_money > 0" style="color: green">￥{{data.check_receipt_money||0}}</strong>
                                    <strong v-if="data.check_receipt_money <= 0" style="color: red">￥{{data.check_receipt_money||0}}</strong>
                                </template>
                            </c-table-column>
                            <c-table-column
                                    name="out_order_number"
                                    label="三方单号"
                                    width="130"
                            >
                            </c-table-column>
                            <c-table-column
                                    name="third_number"
                                    label="三方流水号"
                                    width="130"
                            >
                            </c-table-column>
                            <c-table-column
                                    name="receipt_date"
                                    label="收款日期"
                                    width="130"
                            >
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
            </module-col>
        </module>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'orderCheckDetail',

    components: {
    },

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {},
            check_order_id:0,                  //核销单ID
            check_confirm_id:0,               //核销确认单ID
        }
    },

    computed: {
    },

    methods: {
        /**
         * 加载详情
         */
        detail(){
            this.request({
                url: '/sale/check/confirm/detail',
                data: {
                    id: this.check_confirm_id
                },
                loading: true,
                success: data => {
                    this.detailData = data.confirm_order_detail;
                    this.searchProductHandle();
                }
            });
        },
        /********搜索************/
        searchProductHandle(data){
            if (!data){
                data = {};
            }
            data.check_order_id = this.check_order_id;
            data.check_confirm_id = this.check_confirm_id;
            this.$refs.productList.load({
                url: '/sale/check/product/list',
                data
            });
        },
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.spu_model_name) parts.push(data.spu_model_name);
            if (data.color_name) parts.push(data.color_name);
            if (data.memory_name) parts.push(data.memory_name);
            return parts.join(' ') || '-';
        },
        open(data) {
            this.check_confirm_id = data.id;
            this.check_order_id = data.check_order_id;
            this.detail();
            this.$refs.dialog.open();
        }
    }
}
</script>

<style lang="stylus" scoped>
    .logs-list {
        padding: 10px 10px;

        li {
            padding: 4px 0;
            line-height: 16px;
            font-size: 13px;
            color: #666;
        }
    }
</style>